export const mockGlobalKpi = {
  transactions: 1000,
  paymentAmount: 2000,
  uniqueClients: 3000,
  performance: {
    transactions_performance: 1,
    unique_clients_performance: 2,
    payment_amount_performance: 3,
  },
};

export const mockTimebasedKpi = {
  data: [
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Tue",
      date: "12.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Wed",
      date: "13.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Thu",
      date: "14.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Fri",
      date: "15.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Sat",
      date: "16.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Sun",
      date: "17.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Mon",
      date: "18.01",
    },
    {
      national_customers: 1100,
      international_customers: 1300,
      time_segment: "Tue",
      date: "19.01",
    },
  ],
};
